import React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { withResolver } from 'components/common';
import { BackButton } from 'components/common/Forms';
import { Table, Button } from 'reactstrap';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Magnifier from "react-magnifier";
import { RESELLER } from 'permissions';

export const ContactHistory = ({
  data,
  currentStatus,
  addNotes,
  newEntry,
  savePending,
  saveNote,
  entryChange,
  jobStatuses,
  onBack,
  role,
  ...props
}) => (
  <div>
    <Table size="sm" style={{ fontSize: '85%' }}>
      <thead>
        <tr>
          <th>Date</th>
          <th>Status</th>
          <th>Image</th>
          <th>User</th>
        </tr>
      </thead>
      {data.map(x => (
        <tbody>
        <tr key={x.id}>
          <td>{moment(x.date).format('YYYY-MM-DD HH:mm')}</td>
          <td>{x.status}</td>
          <td>{x.job_image &&
            <Magnifier
              src={x.job_image.image}
              width={300}
              zoomFactor={2}
              mgWidth={400}
              mgHeight={400}
            />
          } </td>
          <td>{x.by_user}</td>
        </tr>
        <tr>
          <td colspan="3">{x.notes}</td>
        </tr>
        </tbody>
      ))}
      {newEntry && (
        <tbody>
          <tr key="new">
            <td>
              <DatePicker
                className="form-control"
                value={moment(newEntry.date).format('YYYY-MM-DD HH:mm')}
                onChange={e => entryChange(e, 'date')}
                viewDateFormat="YYYY-MM-DD HH:mm"
                modelDateFormat="YYYY-MM-DDTHH:mm:00.000Z"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                calendarClassName="with-time"
              />
            </td>
            <td>
              <select
                className="form-control"
                value={newEntry.status}
                onChange={e => entryChange(e, 'status')}
              >
                {jobStatuses.map(i => (
                  <option key={i.value} value={i.value}>
                    {i.text}
                  </option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <textarea rows="4"
                className="form-control"
                onChange={e => entryChange(e, 'notes')}
              />
            </td>
          </tr>
        </tbody>
      )}
    </Table>
    {role !== RESELLER && (
    <center>
      <BackButton className="float-left" onClick={onBack} />
      {savePending ? (
        <Button className="float-right" color="primary" onClick={saveNote}>
          Save
        </Button>
      ) : (
        <Button className="float-right" color="primary" onClick={addNotes}>
          Add Notes
        </Button>
      )}
    </center>
    )}
  </div>
);

const enhance = compose(
  withState('data', 'setData', []),
  withState('newEntry', 'setNewEntry', null),
  withState('savePending', 'setSavePending', false),
  withResolver(
    {
      data: ({ jobId }) => client => client.get('job_contacts/' + jobId),
    },
    {
      onResolved: ({ setData }) => ({ data }) => {
        setData(data);
      },
    }
  ),
  withHandlers({
    addNotes: ({ currentStatus, setNewEntry, setSavePending }) => () => {
      setNewEntry({
        date: moment().format('YYYY-MM-DD HH:mm'),
        status: currentStatus,
        notes: '',
      });
      setSavePending(true);
    },
    entryChange: ({ newEntry, setNewEntry }) => (e, field) => {
      const entry = newEntry;
      if (field === 'date') entry[field] = e.format('YYYY-MM-DD');
      else entry[field] = e.target.value;
      setNewEntry(entry);
    },
    saveNote: ({
      newEntry,
      setSavePending,
      jobId,
      client,
      setData,
      setNewEntry,
    }) => () => {
      client.post('job_contacts/' + jobId, newEntry).then(r => {
        NotificationManager.success('Saved');
        setData(r.data);
        setNewEntry(null);
        setSavePending(false);
      });
    },
  })
);

export default enhance(ContactHistory);



// WEBPACK FOOTER //
// ./src/pages/Jobs/ContactHistory.jsx